import { useEffect, useRef, useState } from 'react';
import useHeightHack from './useHeightHack';
import AuthorizationHelper from 'packages/helpers/AuthorizationHelper';
import { AssetGroup } from 'packages/pages/editor/ContentPickerModal/types';
import features from 'packages/configs/features';
import { UploadType } from 'packages/store/uploads/types';
import { AssetType } from 'packages/pages/components/Uploader/types';

type Props = {
    selectedObject?: any;
    isEditorPage?: boolean;
    preSelectedAsset?: any;
    allowMultiSelect?: boolean;
    type?: AssetType;
};

const useActions = (props: Props) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [assetType, setAssetType] = useState(AssetGroup.GLOBAL);
    const [selectedLocalAssets, setSelectedLocalAssets] = useState<UploadType[]>([]);
    const [collectionId, setCollectionId] = useState(
        !props.isEditorPage ? props.selectedObject?.element?.virtualData?.bynderCollectionId : null,
    );

    useHeightHack({ assetType, wrapperRef });

    useEffect(() => {
        if (assetType === AssetGroup.LOCAL && props.preSelectedAsset?.sourceType === 'INTERNAL') {
            setSelectedLocalAssets([props.preSelectedAsset]);
        }
    }, [assetType]);

    const setSelectedCollection = (selectedCollectionId) => {
        setAssetType(AssetGroup.LOCAL);
        setCollectionId(selectedCollectionId);
    };

    const handleDamClick = () => {
        setAssetType(AssetGroup.GLOBAL);
        setCollectionId(null);
    };

    const onLocalAssetClick = (asset) => {
        // Allow multi-select for images and videos if allowed by prop
        if (!(props.allowMultiSelect && (props.type === 'image' || props.type === 'video' || props.type === 'audio'))) {
            // Single-select: replace selection
            setSelectedLocalAssets([asset]);

            return;
        }

        if (asset.status !== 'PROCESSED' && asset.status !== 'COMPLETED') {
            return;
        }

        setSelectedLocalAssets((prev) => {
            const isSelected = prev.some((a) => a.id === asset.id);

            if (isSelected) {
                return prev.filter((a) => a.id !== asset.id);
            }

            return [...prev, asset];
        });
    };

    const handleBackClick = () => {
        setAssetType(AssetGroup.GLOBAL);
        setCollectionId(null);
    };

    return {
        assetType,
        wrapperRef,
        collectionId,
        selectedLocalAssets,
        handleDamClick,
        setSelectedCollection,
        onLocalAssetClick,
        handleBackClick,
    };
};

export default useActions;
